import { render, staticRenderFns } from "./OcsumReport.vue?vue&type=template&id=57ddfe2f&scoped=true"
import script from "./OcsumReport.ts?vue&type=script&lang=ts&external"
export * from "./OcsumReport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ddfe2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ddfe2f')) {
      api.createRecord('57ddfe2f', component.options)
    } else {
      api.reload('57ddfe2f', component.options)
    }
    module.hot.accept("./OcsumReport.vue?vue&type=template&id=57ddfe2f&scoped=true", function () {
      api.rerender('57ddfe2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/OcsumReport/OcsumReport.vue"
export default component.exports